import Button from "components/Button";
import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";
import { mixins } from "theme/mixins";
import countryPhoto from "../../../../images/country.png";

export const ProfileHighlight = styled.div`
    width: 100%;
    background-color: #fff;
    padding-bottom: 20px;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    border-radius: 14px;

    @media (${theme.breakpoints.mobileL}) {
        padding-bottom: 0;
    }
`;

export const CoverImageWrapper = styled.div`
    position: relative;

    ${Button.Style} {
        display: none;
        position: absolute;
        top: 20px;
        right: 20px;
        background-color: transparent;
        border-color: #fff;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    &:hover {
        ${Button.Style} {
            display: block;
        }
    }
`;

export const ImagePicker = styled.input`
    display: none;
`;

export const CoverImage = styled.div<{ src?: string }>`
    width: 100%;
    min-height: 200px;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    background: ${({ src }) => src && `url(${src})`};
    background-color: #eeeae4;
    background-position-y: center;
    background-size: cover;

    @media (${theme.breakpoints.mobileL}) {
        min-height: 150px;
    }
`;

export const EditProfileOverlay = styled.div`
    cursor: pointer;
    width: 100%;
    height: 100%;
    background-color: rgba(36, 36, 36, 0.5);
    border-radius: 50%;
    display: none;
    justify-content: center;
    align-items: center;
    position: absolute;
`;

export const ProfileImageContainer = styled.div`
    width: 144px;
    height: 144px;
    ${mixins.flexCenter}
    border-radius: 50%;
    margin-left: 26px;
    position: absolute;
    bottom: -72px;
    background-color: #fff;

    &:hover {
        ${EditProfileOverlay} {
            display: flex;
        }
    }

    @media (${theme.breakpoints.mobileL}) {
        width: 100px;
        height: 100px;
        margin-left: 18px;
        bottom: -50px;
    }
`;

export const ProfileImage = styled.div<{ src?: string }>`
    width: calc(100% - 8px);
    height: calc(100% - 8px);
    background-image: ${({ src }) =>
        src ? `url(${src})` : "images/default_user.jpg"};
    background-color: #e5e0d7;
    background-position: center;
    background-size: cover;
    border-radius: 50%;
`;

export const CountryIconContainer = styled.div`
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 30px;
    height: 30px;
    background-color: #fff;
    /* padding: 3px; */
    border-radius: 50%;
`;

export const CountryIcon = styled.div`
    width: 100%;
    height: 100%;
    z-index: 2;
    background-image: url("${countryPhoto}");
    background-position: center;
    background-size: cover;
    border-radius: 50%;
`;

export const DetailSection = styled.div`
    padding-left: 35px;
    padding-right: 21px;
    display: flex;
    flex-direction: column;
    margin-top: 3rem;

    @media (${theme.breakpoints.mobileL}) {
        padding-left: 20px;
    }
`;

export const InstagramIcon = styled.div`
    align-self: flex-end;
    align-items: center;
    display: flex;
    gap: 8px;
`;

export const FlexBetween = styled.div`
    ${mixins.flexBetween};
    margin: 1rem 0;

    @media (${theme.breakpoints.mobileL}) {
        margin-top: 0;
    }
`;

export const ProBadge = styled.img`
    position: absolute;
    z-index: 2;
    right: -30px;
    top: 10px;
`;

export const UserNameSection = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 6px;
    margin-top: 12px;
`;

export const Name = styled(Text)`
    font-size: 30px;

    @media (${theme.breakpoints.mobileL}) {
        font-size: 22px;
    }
`;

export const ButtonSection = styled.div`
    display: flex;
    gap: 17px;
    margin-top: auto;
`;

export const EditButton = styled.div`
    cursor: pointer;
    width: 38px;
    height: 38px;
    position: relative;
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.purple.secondary};
    background-color: ${({ theme }) => theme.colors.purple.tertiary};
    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const ShareButton = styled(Button)`
    height: 38px;
    box-shadow: 0px 4px 14px rgb(136 104 234 / 30%);
`;

export const ShareButtonContent = styled.div`
    ${({ theme }) => theme.mixins.flexCenter};
    gap: 8px;
`;

export const ShareIcons = styled.div`
    margin: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
`;

export const ShareIcon = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    transition: 200ms all ease-in-out;

    svg {
        cursor: pointer;
        font-size: 50px;

        * {
            fill: ${({ theme }) => theme.colors.grey.dark};
        }
    }

    &:hover {
        svg {
            * {
                fill: ${({ theme }) => theme.colors.purple.primary};
            }
        }
    }
`;

export const BottomRow = styled(FlexBetween)`
    padding-right: 40px;
    display: none;
`;

export const ListSection = styled.div`
    display: flex;
    align-items: center;
    gap: 68px;
`;

export const ListItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
